import { Component, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { BooleanPipe } from '@core/pipes/boolean.pipe';
import { CprNummerPipe } from '@core/pipes/cprnummer.pipe';
import { PersonHelbredHistorikComponent } from '@features/helbred/person-helbred-historik/person-helbred-historik.component';
import { PersonHelbredComponent } from '@features/helbred/person-helbred/person-helbred.component';
import { KunderService } from '@features/kunder/kunder.service';
import dayjs from 'dayjs';
import { ButtonModule } from 'primeng/button';
import { ScrollPanelModule } from 'primeng/scrollpanel';

@Component({
  selector: 'app-kunde-detail',
  imports: [
    ScrollPanelModule,
    ReactiveFormsModule,
    ButtonModule,
    BooleanPipe,
    PersonHelbredComponent,
    PersonHelbredHistorikComponent,
    CprNummerPipe,
    RouterLink,
  ],
  templateUrl: './kunde-detail.component.html',
  styleUrl: './kunde-detail.component.css',
})
export class KundeDetailComponent {
  kundeService = inject(KunderService);

  onDateSelected(v: string) {
    const dato = dayjs(v).add(1, 'day').toDate();
    this.kundeService.helbredsDato.set(dato);
  }
}
